var _excluded = ["checked", "disabled", "defaultChecked", "className", "children", "style", "onChange"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { cx } from '@emotion/css';
import { styleRadio, prefix, prefixCompName } from "./index.style";
import { GroupContext } from "./Group";
import useThemeProps from "../../hooks/useThemeProps";

var InternalRadio = function InternalRadio(_ref, ref) {
  var _cx, _cx2;

  var checked = _ref.checked,
      disabled = _ref.disabled,
      defaultChecked = _ref.defaultChecked,
      className = _ref.className,
      children = _ref.children,
      style = _ref.style,
      onChange = _ref.onChange,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var c = useThemeProps();
  var radioGroup = React.useContext(GroupContext);

  var _React$useState = React.useState(Boolean(checked) || Boolean(defaultChecked)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentChecked = _React$useState2[0],
      setCurrentChecked = _React$useState2[1];

  var radioProps = _objectSpread({}, restProps);

  var mergedDisabled = (radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.disabled) || disabled;

  var onChangeHandler = function onChangeHandler(e) {
    var _radioGroup$changeRad;

    if (mergedDisabled) {
      e.stopPropagation();
      return;
    }

    var targetChecked = e.target.checked;

    if (checked === undefined) {
      setCurrentChecked(targetChecked);
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(targetChecked, e);
    radioGroup === null || radioGroup === void 0 ? void 0 : (_radioGroup$changeRad = radioGroup.changeRadio) === null || _radioGroup$changeRad === void 0 ? void 0 : _radioGroup$changeRad.call(radioGroup, e);
  };

  if (radioGroup) {
    radioProps.name = radioGroup.name;
  }

  React.useEffect(function () {
    if (checked !== undefined) {
      setCurrentChecked(Boolean(checked));
    }

    if (radioGroup) {
      setCurrentChecked((radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.value) === restProps.value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [checked, radioGroup]);
  return /*#__PURE__*/React.createElement("label", {
    style: style,
    className: cx(prefix('wrapper')(), styleRadio(c), (_cx = {}, _defineProperty(_cx, prefix('wrapper-checked')(), currentChecked), _defineProperty(_cx, prefix('wrapper-disabled')(), mergedDisabled), _cx), className)
  }, /*#__PURE__*/React.createElement("span", {
    className: cx(prefixCompName(), (_cx2 = {}, _defineProperty(_cx2, prefix('checked')(), currentChecked), _defineProperty(_cx2, prefix('disabled')(), mergedDisabled), _cx2))
  }, /*#__PURE__*/React.createElement("input", _extends({}, radioProps, {
    checked: currentChecked,
    disabled: mergedDisabled,
    ref: ref,
    className: prefix('input')(),
    onChange: onChangeHandler,
    type: "radio"
  })), /*#__PURE__*/React.createElement("span", {
    className: prefix('inner')()
  })), children && /*#__PURE__*/React.createElement("span", null, children));
};

var Radio = /*#__PURE__*/React.forwardRef(InternalRadio);
Radio.displayName = 'Radio';
Radio.defaultProps = {
  defaultChecked: false,
  disabled: false
};
export default /*#__PURE__*/React.memo(Radio);